import { useMemo } from 'react'
import classNames from 'classnames'
import { ParagraphSM, TitleMD } from '@/atoms/Text'

export function ProfileUser(props: { firstName: string; lastName: string; email: string; className?: string }) {
  // TODO: replace with user.profile.name when new graphql property is created
  const name = useMemo(() => {
    const name = [props.firstName, props.lastName].filter(Boolean).join(' ')

    if (name.trim().length === 0) return undefined

    return name
  }, [props.firstName, props.lastName])

  return (
    <div className={classNames('flex min-w-0 flex-col gap-0', props.className)}>
      {name && (
        <TitleMD weight="semibold" className="truncate">
          {name}
        </TitleMD>
      )}
      <ParagraphSM className="-mt-1 truncate">{props.email}</ParagraphSM>
    </div>
  )
}
